import idioms from "../idioms.json";
import { toPairs } from "lodash-es";

export const is60PercentMatch = (str1: string, str2: string) => {
  const str1Words = str1.trim().split(" ");
  const str2Words = str2.trim().split(" ");
  let count = 0;
  str1Words.forEach((word) => {
    if (str2Words.includes(word)) count++;
  });
  return count / str1Words.length >= 0.6;
};

export const findallMatchingIdioms = (searchTerm: string) => {
  // declare matchingIdiomsArray as an array of arrays of strings
  let matchingIdiomsArray: string[][] = [];
  toPairs(idioms)?.forEach((idiom) => {
    if (is60PercentMatch(idiom[0].toLowerCase(), searchTerm.toLowerCase()))
      matchingIdiomsArray.push([idiom[0], idiom[1]]);
    else if (is60PercentMatch(idiom[1].toLowerCase(), searchTerm.toLowerCase()))
      matchingIdiomsArray.push([idiom[1], idiom[0]]);
  });
  return matchingIdiomsArray;
};

function fallbackCopyTextToClipboard(text: string) {
  var textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }
}

export function copyTextToClipboard(text: string) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    console.log('Async: Copying to clipboard was successful!');
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
};
